export enum NftFormat {
  image = 'image',
  audio = 'audio',
  video = 'video',
  model = 'model',
}
